module.exports = __webpack_public_path__ + "static/media/sdk.7b6e2b39.webp";